import React, { useEffect, useState } from "react";
import { Modal, DatePicker } from "antd";
import moment from "moment";

/**
 * Modal for setting (or clearing) an expiry date on one or more files.
 * `initialExpiry` is an ISO date string ("YYYY-MM-DD") or null.
 */
const SetExpiryModal = ({
  visible,
  initialExpiry = null,
  onCancel,
  onConfirm,
  confirmLoading = false,
  fileCount = 1,
}) => {
  const [date, setDate] = useState(initialExpiry ? moment(initialExpiry) : null);

  useEffect(() => {
    if (visible) {
      setDate(initialExpiry ? moment(initialExpiry) : null);
    }
  }, [visible, initialExpiry]);

  const handleOk = () => {
    onConfirm(date ? date.format("YYYY-MM-DD") : null);
  };

  return (
    <Modal
      title={
        fileCount > 1
          ? `Set expiry on ${fileCount} files`
          : "Set expiry date"
      }
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText="Save"
      confirmLoading={confirmLoading}
      destroyOnClose
      zIndex={1200}
      wrapClassName="file-manager-bulk-modal"
    >
      <DatePicker
        style={{ width: "100%" }}
        value={date}
        onChange={(value) => setDate(value)}
        placeholder="Select expiry date"
        // Display in AU DD/MM/YYYY; the wire format passed to the API
        // (in handleOk → date.format("YYYY-MM-DD")) stays ISO so the
        // backend doesn't have to know about display locale.
        format="DD/MM/YYYY"
        getPopupContainer={(trigger) => trigger.parentNode}
      />
      <div style={{ marginTop: 12, fontSize: 12, color: "#888" }}>
        Leave empty to remove the expiry date.
      </div>
    </Modal>
  );
};

export default SetExpiryModal;
